// extracted by mini-css-extract-plugin
export default {"formWrapper":"style_formWrapper__TGsb2","title":"style_title__JNmRU","forgotPassword":"style_forgotPassword__RsazT","button":"style_button__WbC+e"};